import { Box, Link, Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { upperCase } from 'lodash';

import { Loader, TextLine } from 'core/elements';
import { Warning } from 'core/elements';
import { NumberHelper } from 'core/helpers';
import { getAgGridTableCellData } from 'core/utils';
import { IQuotePart } from 'quotes/types';
import { Size } from 'theme/enums';

interface IProps extends ICellRendererParams {
  quantityField?: string;
  uomField?: string;
  onClick?: (data: IQuotePart) => void;
}

const verifiedPartLinkStyle = {
  justifyContent: 'flex-end',
};

const unverifiedPartLinkStyle = {
  ...verifiedPartLinkStyle,
  cursor: 'default',
  '&:hover': {
    textDecorationLine: 'none',
  },
};

const InventoryCell = ({ quantityField, uomField, onClick, ...props }: IProps) => {
  const data = getAgGridTableCellData(props, props.colDef.colId);

  if (!data) {
    return <></>;
  }

  const inventoryData = props.value;
  const hasInventory = Boolean(inventoryData?.[quantityField]);

  if (inventoryData?.isLoading) {
    return <Loader size={Size.SM} />;
  }

  const error = inventoryData?.error;

  if (error) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Warning tooltipTitle={error} />
      </Box>
    );
  }

  const hasDetails = data.verified || data.alternateVersionEnabled;

  return (
    <Stack gap={0} justifyContent="flex-end">
      <Link
        onClick={() => (hasDetails ? onClick(data) : null)}
        sx={hasDetails ? verifiedPartLinkStyle : unverifiedPartLinkStyle}
      >
        {NumberHelper.format({
          amount: inventoryData?.[quantityField],
          displayZero: false,
        })}
      </Link>

      {hasInventory && <TextLine text={upperCase(inventoryData?.[uomField])} isSubText />}
    </Stack>
  );
};

export default InventoryCell;
